import { Decimal, ZERO } from '@snap-types/types/decimal';
import type { Nullish } from '@snap-types/types/nullish';

export function maybeDivide(
  numerator: Nullish<Decimal.Value>,
  denominator: Nullish<Decimal.Value>,
): Decimal {
  if (!numerator) {
    return ZERO;
  }

  if (!denominator) {
    throw new Error(`Must provide a denominator, got: ${denominator}`);
  }

  return new Decimal(numerator).dividedBy(new Decimal(denominator));
}

export function maybeMultiply(
  left: Nullish<Decimal.Value>,
  right: Nullish<Decimal.Value>,
): Decimal {
  if (left && right) {
    return new Decimal(left).times(new Decimal(right));
  }

  return ZERO;
}
